// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__HzlFr","location":"Header_location__2h624"};